import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import PageTitle from '../controls/PageTitle'
import * as TimeseriesActionCreators from '../../actions/timeseries'
import * as AlertRulesActionCreators from '../../actions/alertRule'
import AlertRulesListView from './AlertRulesListView'

class AlertRulesListPage extends React.Component {
  static propTypes = {
    /* HOC/middleware props */
    match: PropTypes.object.isRequired,
    /* mapped state */
    timeseries: PropTypes.object.isRequired,
    timeseriesByUnit: PropTypes.object.isRequired,
    alertRules: PropTypes.object.isRequired,
    alertRulesByUnit: PropTypes.object.isRequired,
    /* mapped dispatch */
    timeseriesActions: PropTypes.object.isRequired,
    alertRuleActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      timeseries: state.timeseries,
      timeseriesByUnit: state.timeseriesByUnit,
      alertRules: state.alertRules,
      alertRulesByUnit: state.alertRulesByUnit,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      timeseriesActions: bindActionCreators(TimeseriesActionCreators, dispatch),
      alertRuleActions: bindActionCreators(AlertRulesActionCreators, dispatch),
    }
  }

  componentDidMount() {
    const { timeseriesActions, alertRuleActions } = this.props
    timeseriesActions.listUnitTimeseries(this.unitId())
    alertRuleActions.listAlertRulesByUnit(this.unitId())
  }

  unitId() {
    return parseInt(this.props.match.params.unitId, 10)
  }

  unitAlertRules() {
    const { alertRules, alertRulesByUnit } = this.props
    const ruleIds = alertRulesByUnit[this.unitId()] || []
    const unitRules = ruleIds.reduce((obj, id) => ({
      ...obj,
      [id]: alertRules[id],
    }), {})

    return unitRules
  }

  unitTimeseries() {
    const {
      timeseries, timeseriesByUnit,
    } = this.props
    const tsIds = timeseriesByUnit[this.unitId()] || []
    return tsIds.map((tsId) => timeseries[tsId])
  }

  render() {
    const { alertRuleActions } = this.props
    return (
      <>
        <PageTitle title="Alert Rules" />
        <AlertRulesListView
          timeseries={this.unitTimeseries()}
          alertRules={this.unitAlertRules()}
          onSave={alertRuleActions.saveAlertRule}
          onAdd={alertRuleActions.addAlertRule}
        />
      </>
    )
  }
}

export default connect(
  AlertRulesListPage.mapStateToProps,
  AlertRulesListPage.mapDispatchToProps,
)(AlertRulesListPage)
